<form [formGroup]="formGroup">
  <country-wrapper>
    <ng-template country="NZ">
      <lds-numeric-input
        formControlName="mobile"
        [label]="label"
        [allowLeadingZeros]="allowLeadingZeros"
        [isRequired]="isRequired"
        [minlength]="9"
        placeholder="02XXXXXXXX"
        [maxlength]="12"
        (sparkPasteNumbersOnly)="onPasteDigits($event)"
        [validations]="{
          required: 'Mobile number is required',
          mobileNumberValidator: 'Must be a valid mobile number'
        }">
      </lds-numeric-input>
    </ng-template>
    <ng-template countryDefault>
      <lds-mobile-input
        formControlName="mobile"
        label="Mobile number"
        countryCode="AU"
        [isRequired]="isRequired"
        (sparkPasteNumbersOnly)="onPasteDigits($event)"
        [validations]="{
          required: 'Mobile number is required',
          mobileNumberValidator: 'Please enter a valid AU mobile number'
        }">
      </lds-mobile-input>
    </ng-template>
  </country-wrapper>
</form>
